import { IApiError } from '@/models/apiError.model';
import { IGeneralFaq } from '@/models/generalFaq.model';
import { IPagination } from '@/models/pagination.model';

export const SLICE_NAME = 'generalFaq';

export interface GeneralFaqState {
  faqs: IGeneralFaq[] | null;
  isLoading: boolean;
  error: IApiError | null;
  pagination: IPagination | null;
}

export const initialState: GeneralFaqState = {
  faqs: null,
  pagination: null,
  isLoading: false,
  error: null,
};
